module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/31ruxhecNaEqCsYSousacq-5284bf03cde21c06814eaacef409629e.jpg";